import { LocationCardMessages } from '../location-card/location-card.types';

export type LocationCardCarouselMessages = LocationCardMessages;

export enum LocationCardCarouselDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
